import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type PartnerService from 'teacher-ui-client/services/partner'
import type Store from '@ember-data/store'
import type { Log } from '@blakeelearning/log'
import type RouterService from '@ember/routing/router-service'
import type PartnerContactDetail from 'teacher-ui-client/models/partner-contact-detail'

export default class extends Route {
  @service session!: SessionService

  @service partner!: PartnerService

  @service store!: Store

  @service log!: Log

  @service router!: RouterService

  buildRouteInfoMetadata() {
    return { allowUnauthorizedSubscription: true }
  }

  async model() {
    const {
      currentSchool: { schoolCode },
    } = this.session

    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute

    const partner = this.partner.partnerForSubscriptionType(subscriptionType)
    if (!partner) {
      this.log.error('school partner not found for subscription type on contact us page', {
        schoolCode,
        subscriptionType,
      })
      void this.router.replaceWith('subscription-type.home')
      return { subscriptionType }
    }

    const partnerId = partner.id
    const partnerDetails = await this.store.findAll<PartnerContactDetail>('partner-contact-detail', {
      adapterOptions: { partnerId },
    })
    const partnerDetailsForSub = partnerDetails.find((details) => details.subscriptionType === subscriptionType)

    return {
      subscriptionType,
      partnerDetailsForSub,
    }
  }
}
